"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processError = void 0;
const tslib_1 = require("tslib");
const code_frame_1 = require("@babel/code-frame");
const client_common_1 = require("@neo-one/client-common");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const source_map_1 = require("source-map");
const utils_1 = require("./utils");
const CALLSITE_INDENT = '    ';
const MESSAGE_INDENT = `${CALLSITE_INDENT}  `;
const getRenderedCallsite = (fileContent, line, column) => {
    let renderedCallsite = code_frame_1.codeFrameColumns(fileContent, { start: { column, line } }, { highlightCode: true });
    renderedCallsite = renderedCallsite
        .split('\n')
        .map((renderedLine) => MESSAGE_INDENT + renderedLine)
        .join('\n');
    renderedCallsite = `\n${renderedCallsite}\n`;
    return renderedCallsite;
};
const getSourceMapPosition = ({ lineNumber, consumer, }) => {
    const { source, line, column } = consumer.originalPositionFor({ line: lineNumber, column: 0 });
    if (source === null || line === null) {
        return undefined;
    }
    const sourceContent = consumer.sourceContentFor(source, true);
    if (sourceContent === null) {
        return undefined;
    }
    return getRenderedCallsite(sourceContent, line, column === null ? undefined : column + 1);
};
const processGenericError = async (message, sourceMaps) => {
    const mutableMessage = message.trim().split('\n');
    const scriptHash = mutableMessage.find((splitLine) => splitLine.startsWith('Script Hash:'));
    let address;
    if (scriptHash !== undefined) {
        address = client_common_1.scriptHashToAddress(scriptHash.split(':')[1]);
    }
    let sourceMap = Object.values(sourceMaps)[0];
    if (address !== undefined && sourceMaps[address] !== undefined) {
        sourceMap = sourceMaps[address];
    }
    const line = mutableMessage.find((splitLine) => splitLine.startsWith('Line:'));
    if (line === undefined) {
        return message;
    }
    return source_map_1.SourceMapConsumer.with(sourceMap, undefined, async (consumer) => {
        const lineNumber = parseInt(line.split(':')[1], 10);
        const positionMessage = getSourceMapPosition({ lineNumber, consumer });
        if (positionMessage === undefined) {
            return message;
        }
        return `${mutableMessage[0]}\n${positionMessage}\n\n`;
    });
};
const processTraceError = async (message, error, trace, sourceMaps) => {
    let sourceMap = Object.values(sourceMaps)[0];
    if (sourceMaps[error.address] !== undefined) {
        sourceMap = sourceMaps[error.address];
    }
    return source_map_1.SourceMapConsumer.with(sourceMap, undefined, async (consumer) => {
        const positionMessage = getSourceMapPosition({ lineNumber: error.line, consumer });
        if (positionMessage === undefined) {
            return message;
        }
        const mutableTraceLines = [];
        for (const { line: lineNumber } of trace) {
            const { source, line, column } = consumer.originalPositionFor({ line: lineNumber, column: 0 });
            if (source === null || line === null) {
                return message;
            }
            const sourceContent = consumer.sourceContentFor(source, true);
            let sourceValue;
            if (sourceContent !== null && column !== null) {
                const sourceLine = sourceContent.split('\n')[line - 1];
                if (sourceLine !== undefined) {
                    sourceValue = utils_1.getChunk(sourceLine.slice(column));
                }
            }
            if (sourceValue === undefined || sourceValue.trim() === '') {
                sourceValue = 'unknown';
            }
            mutableTraceLines.push(`${MESSAGE_INDENT}at ${sourceValue} (${source}:${line}${column === null ? '' : `:${column}`})`);
        }
        return `${error.message}\n${positionMessage}${mutableTraceLines.join('\n')}`;
    });
};
exports.processError = async ({ message, error, trace = [], sourceMaps, }) => {
    if (sourceMaps === undefined || lodash_1.default.isEmpty(sourceMaps)) {
        return message;
    }
    if (error === undefined) {
        return processGenericError(message, sourceMaps);
    }
    return processTraceError(message, error, trace, sourceMaps);
};

//# sourceMappingURL=processError.js.map
